export default "__VITE_PUBLIC_ASSET__00b5e1fa__"